// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3dhMz","inner":"Footer_inner__3j6uP"};